export const SET_SELECTED_CALENDAR_ITEMS = "SET_SELECTED_CALENDAR_ITEMS";

export interface ISetSelectedCalendarItems {
  type: typeof SET_SELECTED_CALENDAR_ITEMS;
  payload: any[];
}

export const SET_CALENDAR_ACTION = "SET_CALENDAR_ACTION";

export interface ISetCalendarAction {
  type: typeof SET_CALENDAR_ACTION;
  payload: string;
}

export const SET_CALENDAR_CONTEXT_ACTION = "SET_CALENDAR_CONTEXT_ACTION";

export interface ISetCalendarContextAction {
  type: typeof SET_CALENDAR_CONTEXT_ACTION;
  payload: ContextAction;
}

export const HANDLE_RESCHEDULE_GROUP_STUDENT_CALENDAR = "HANDLE_RESCHEDULE_GROUP_STUDENT_CALENDAR";

export interface IHandleRescheduleGroupStudentCalendar {
  type: typeof HANDLE_RESCHEDULE_GROUP_STUDENT_CALENDAR;
  payload: Partial<RescheduleGroupRequest>;
}

export const HANDLE_RESCHEDULE_GROUP_CLASS_CALENDAR = "HANDLE_RESCHEDULE_GROUP_CLASS_CALENDAR";

export interface IHandleRescheduleGroupClassCalendar {
  type: typeof HANDLE_RESCHEDULE_GROUP_CLASS_CALENDAR;
  payload: RescheduleGroupRequest;
}
